<div class="min-h-screen flex items-center justify-center bg-[var(--bg-dark)] text-white relative overflow-hidden">

  <!-- Abstract Background Elements -->
  <div
    class="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-[#506ef7]/20 rounded-full blur-[100px] pointer-events-none">
  </div>
  <div
    class="absolute bottom-[-10%] right-[-10%] w-[30%] h-[30%] bg-indigo-500/10 rounded-full blur-[80px] pointer-events-none">
  </div>

  <div
    class="w-full max-w-md p-8 bg-[var(--bg-panel)] border border-[#ffffff10] rounded-2xl shadow-2xl relative z-10 animate-fade-in backdrop-blur-xl">

    <!-- Header / Logo -->
    <div class="flex flex-col items-center mb-8">
      <div
        class="w-12 h-12 rounded-xl bg-gradient-to-br from-[#506ef7] to-[#8095fb] flex items-center justify-center shadow-lg shadow-[#506ef7]/30 mb-4 group hover:scale-105 transition-transform duration-300 cursor-default">
        <svg xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6 text-white group-hover:animate-[wiggle_1s_ease-in-out_infinite]" fill="none"
          viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
      </div>
      <h2
        class="text-4xl font-black tracking-tight text-transparent bg-clip-text bg-gradient-to-br from-white via-blue-50 to-[#8095fb] mb-1 drop-shadow-md">
        Discont</h2>
      <p
        class="text-[10px] font-bold text-[var(--text-muted)] uppercase tracking-[0.2em] text-center opacity-60 hover:opacity-100 hover:text-[#8095fb] transition-all duration-300 cursor-default">
        Distributed Content</p>
    </div>

    <!-- Login Form -->
    <form class="flex flex-col gap-5" [formGroup]="form" (ngSubmit)="onSubmit()">

      <!-- Error Message Banner -->
      @if (errorMessage()) {
        <div role="alert" class="bg-red-500/10 border border-red-500/50 text-red-400 px-4 py-3 rounded-xl text-sm flex items-start gap-3 animate-fade-in">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
          <span>{{ errorMessage() }}</span>
        </div>
      }

      <!-- Email -->
      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-medium text-[var(--text-muted)] ml-1">Work Email</label>
        <div class="relative group">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg class="h-5 w-5 text-[var(--text-muted)] group-focus-within:text-[#506ef7] transition-colors"
              fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
            </svg>
          </div>
          <input type="email" formControlName="email" autocomplete="email"
            class="w-full pl-10 pr-4 py-3 bg-[#ffffff05] border border-[#ffffff10] rounded-xl text-white placeholder-[#ffffff40] focus:outline-none focus:border-[#506ef7] focus:ring-1 focus:ring-[#506ef7] transition-all"
            placeholder="admin@system.io">
        </div>
      </div>

      <!-- Password -->
      <div class="flex flex-col gap-1.5 mt-1">
        <div class="flex justify-between items-center ml-1">
          <label class="text-sm font-medium text-[var(--text-muted)]">Password</label>
          <a href="#" class="text-xs text-[#506ef7] hover:text-white transition-colors">Forgot password?</a>
        </div>
        <div class="relative group">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg class="h-5 w-5 text-[var(--text-muted)] group-focus-within:text-[#506ef7] transition-colors"
              fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <input type="password" formControlName="password" autocomplete="current-password"
            class="w-full pl-10 pr-4 py-3 bg-[#ffffff05] border border-[#ffffff10] rounded-xl text-white placeholder-[#ffffff40] focus:outline-none focus:border-[#506ef7] focus:ring-1 focus:ring-[#506ef7] transition-all"
            placeholder="••••••••">
        </div>
      </div>

      <!-- Keep me signed in -->
      <div class="flex items-center gap-2 mt-1">
        <input type="checkbox" id="remember"
          class="w-4 h-4 rounded border-[#ffffff20] bg-[#ffffff05] text-[#506ef7] focus:ring-[#506ef7] focus:ring-offset-0 cursor-pointer">
        <label for="remember" class="text-sm text-[var(--text-muted)] cursor-pointer">Keep me signed in</label>
      </div>

      <!-- Submit Button -->
      <button type="submit" [disabled]="isLoading()"
        class="w-full py-3 px-4 mt-2 bg-[#506ef7] hover:bg-[#4057db] text-white font-medium rounded-xl shadow-[0_4px_14px_0_rgba(80,110,247,0.39)] hover:shadow-[0_6px_20px_rgba(80,110,247,0.23)] transition-all relative overflow-hidden group flex justify-center items-center h-12"
        [class.opacity-70]="isLoading()" [class.cursor-not-allowed]="isLoading()" [class.hover:-translate-y-0.5]="!isLoading()">

        @if (isLoading()) {
          <svg class="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span class="relative z-10">Signing In...</span>
        } @else {
          <span class="relative z-10">Sign In</span>
        }
        <div
          class="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-[#ffffff20] to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]">
        </div>
      </button>

    </form>

    <div class="mt-8 pt-6 border-t border-[#ffffff10] text-center">
      <p class="text-xs text-[var(--text-muted)]">Secure Access Managed by ❤️ Amatis</p>
    </div>

  </div>
</div>